/* tslint:disable */
/* eslint-disable */
/**
 * crm
 * crm
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApfmMobilityResponse
 */
export interface ApfmMobilityResponse {
    /**
     * 
     * @type {string}
     * @memberof ApfmMobilityResponse
     */
    profile_ambulation?: string;
    /**
     * 
     * @type {string}
     * @memberof ApfmMobilityResponse
     */
    profile_wheelchair_assistance?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApfmMobilityResponse
     */
    profile_wheelchair_move_from?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApfmMobilityResponse
     */
    profile_wheelchair_self_propel?: boolean;
}

/**
 * Check if a given object implements the ApfmMobilityResponse interface.
 */
export function instanceOfApfmMobilityResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApfmMobilityResponseFromJSON(json: any): ApfmMobilityResponse {
    return ApfmMobilityResponseFromJSONTyped(json, false);
}

export function ApfmMobilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApfmMobilityResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'profile_ambulation': !exists(json, 'profile_ambulation') ? undefined : json['profile_ambulation'],
        'profile_wheelchair_assistance': !exists(json, 'profile_wheelchair_assistance') ? undefined : json['profile_wheelchair_assistance'],
        'profile_wheelchair_move_from': !exists(json, 'profile_wheelchair_move_from') ? undefined : json['profile_wheelchair_move_from'],
        'profile_wheelchair_self_propel': !exists(json, 'profile_wheelchair_self_propel') ? undefined : json['profile_wheelchair_self_propel'],
    };
}

export function ApfmMobilityResponseToJSON(value?: ApfmMobilityResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'profile_ambulation': value.profile_ambulation,
        'profile_wheelchair_assistance': value.profile_wheelchair_assistance,
        'profile_wheelchair_move_from': value.profile_wheelchair_move_from,
        'profile_wheelchair_self_propel': value.profile_wheelchair_self_propel,
    };
}

